"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToBuffer = exports.bufferToString = exports.unpackMessage = exports.packMessage = exports.extractHeaderData = void 0;
const util_1 = require("util");
const ActualTextDecoder = util_1.TextDecoder ? util_1.TextDecoder : window.TextDecoder;
const ActualTextEncoder = util_1.TextEncoder ? util_1.TextEncoder : window.TextEncoder;
function cirrusStoreSocket(createSocket) {
    const socket = createSocket();
    let currentBinaryMessageId = 0;
    const generateBinaryMessageId = () => {
        return currentBinaryMessageId++ % 1000000;
    };
    function storePutRequest(message, arrayBuffers) {
        return __awaiter(this, void 0, void 0, function* () {
            if (arrayBuffers.length !== 1) {
                throw new Error('Sending multiple buffers is not supported in Cirrus.');
            }
            const binaryMessageIds = [];
            const wrappedArrayBuffers = [];
            for (const arrayBuffer of arrayBuffers) {
                const binaryMessageId = generateBinaryMessageId();
                binaryMessageIds.push(binaryMessageId);
                wrappedArrayBuffers.push(yield packMessage(arrayBuffer, binaryMessageId));
            }
            const responsePromise = socket.request(Object.assign(Object.assign({}, message), { binary: {
                    resourceType: 'BinaryWrapperDTO',
                    binaryMessageId: binaryMessageIds[0],
                } }));
            for (const arrayBuffer of wrappedArrayBuffers) {
                socket.sendBinary(arrayBuffer);
            }
            return responsePromise;
        });
    }
    function storeGetRequest(message) {
        var _a;
        return __asyncGenerator(this, arguments, function* storeGetRequest_1() {
            var e_1, _b;
            const binaries = socket.watchBinary();
            const response = yield __await(socket.request(message));
            let relevantIds = [(_a = response.binary) === null || _a === void 0 ? void 0 : _a.binaryMessageId];
            if (relevantIds.filter(Boolean).length === 0) {
                binaries.return();
                throw new Error('No binaryMessageIds found!');
            }
            try {
                for (var binaries_1 = __asyncValues(binaries), binaries_1_1; binaries_1_1 = yield __await(binaries_1.next()), !binaries_1_1.done;) {
                    const binary = binaries_1_1.value;
                    const { body, binaryMessageId } = yield __await(unpackMessage(binary));
                    if (relevantIds.find(id => id === binaryMessageId)) {
                        yield yield __await(body);
                        relevantIds = relevantIds.filter(n => n !== binaryMessageId);
                    }
                    if (relevantIds.length === 0) {
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (binaries_1_1 && !binaries_1_1.done && (_b = binaries_1.return)) yield __await(_b.call(binaries_1));
                }
                finally { if (e_1) throw e_1.error; }
            }
            binaries.return();
            return yield __await(response);
        });
    }
    return Object.assign(Object.assign({}, socket), { storePutRequest,
        storeGetRequest });
}
exports.default = cirrusStoreSocket;
const extractHeaderData = (header) => __awaiter(void 0, void 0, void 0, function* () {
    const view = new DataView(header);
    const messageType = view.getInt8(0);
    const binaryMessageId = view.getUint32(12);
    return {
        messageType,
        binaryMessageId,
    };
});
exports.extractHeaderData = extractHeaderData;
function packMessage(body, binaryMessageId) {
    return __awaiter(this, void 0, void 0, function* () {
        const buffer = new ArrayBuffer(24 + body.byteLength);
        const view = new Uint8Array(buffer);
        const dataView = new DataView(buffer);
        view.fill(0);
        dataView.setUint8(0, 1);
        dataView.setUint32(12, binaryMessageId);
        view.set(new Uint8Array(body), 24);
        return buffer;
    });
}
exports.packMessage = packMessage;
function unpackMessage(arrayBuffer) {
    return __awaiter(this, void 0, void 0, function* () {
        const header = arrayBuffer.slice(0, 24);
        const body = arrayBuffer.slice(24);
        const { messageType, binaryMessageId } = yield exports.extractHeaderData(header);
        return {
            messageType,
            binaryMessageId,
            body,
        };
    });
}
exports.unpackMessage = unpackMessage;
function bufferToString(buf) {
    return new ActualTextDecoder().decode(buf);
}
exports.bufferToString = bufferToString;
function stringToBuffer(str) {
    return new ActualTextEncoder().encode(str).buffer;
}
exports.stringToBuffer = stringToBuffer;
//# sourceMappingURL=cirrusStoreSocket.js.map